// Fixed timestep 128Hz + interpolação de render — contrato da docs/01. NÃO acoplar
// física ao delta do rAF.
import { TICK_DT } from '@surfrun/shared';

export interface LoopHooks {
  tick: (tickIndex: number) => void;
  render: (alpha: number, dtReal: number) => void;
}

export class GameLoop {
  tickIndex = 0;
  private acc = 0;
  private last = 0;
  private raf = 0;
  private running = false;

  constructor(private hooks: LoopHooks) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    const frame = (now: number) => {
      if (!this.running) return;
      let dt = (now - this.last) / 1000;
      this.last = now;
      if (dt > 0.25) dt = 0.25; // clamp (aba em background etc.)
      this.acc += dt;
      while (this.acc >= TICK_DT) {
        this.hooks.tick(this.tickIndex++);
        this.acc -= TICK_DT;
      }
      this.hooks.render(this.acc / TICK_DT, dt);
      this.raf = requestAnimationFrame(frame);
    };
    this.raf = requestAnimationFrame(frame);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.raf);
  }
}
